import { ListItem, ListItemAvatar, ListItemText, Skeleton } from '@mui/material'
import { SkeletonText } from 'utoniq-ui'

import { Cell } from '@/core/architecture'

type CampaignBoxSkeletonProps = {}

export const CampaignBoxSkeleton: Cell<CampaignBoxSkeletonProps> = () => (
  <ListItem sx={{ p: 0, mb: 5 }}>
    <ListItemAvatar>
      <Skeleton variant="rectangular" sx={{ width: 100, height: 64 }} />
    </ListItemAvatar>
    <ListItemText
      sx={{ pl: 4 }}
      primary={<SkeletonText variant="large" width="50%" />}
      secondary={<SkeletonText variant="medium" width="100%" />}
    />
  </ListItem>
)
